import React from 'react';
import {CardType} from "../../models/api/codegen/code";
import {SwitcherChildBlocks} from "../Line/SwitcherChildBlocks";

export const SwitcherChildBlocksCard: React.FC<{ card: CardType }> = ({card}) => {
    return <SwitcherChildBlocks/>
}
